import { useTypeDocumentIdentification } from '@hooks/use-type-document-identification';
import { useTypeRegimes } from '@hooks/use-type-regimes';
import { useMunicipality } from '@hooks/use-municipality';
import { useTypeOrganization } from '@hooks/use-type-organization';

type Props = {
  isLoading: boolean;
  data: any;
};
export const useCustomerCommons = (): Props => {
  const typeDocumentIdentification = useTypeDocumentIdentification();
  const typeRegime = useTypeRegimes();
  const municipality = useMunicipality();
  const typeOrganization = useTypeOrganization();
  if (
    typeDocumentIdentification.isLoading ||
    typeRegime.isLoading ||
    municipality.isLoading ||
    typeOrganization.isLoading
  ) {
    return { isLoading: true, data: null };
  }
  return {
    isLoading: false,
    data: {
      typeDocumentIdentification: typeDocumentIdentification.data,
      typeRegime: typeRegime.data,
      municipality: municipality.data,
      typeOrganization: typeOrganization.data,
    },
  };
};
